const getQueryParametersFromActiveFilters = (activeFilters) => {
    let queryParameters = "";
    for (const [key, items] of Object.entries(activeFilters)) {
        let value;
        if (Array.isArray(items)) {
            let values = items.map(item => {
                return getValueWithOrWithoutQuotes(key, item.value);
            });
            value = values.join(",");
        }
        else {
            value = getValueWithOrWithoutQuotes(key, items.value);
        }
        queryParameters += "&" + key + "=" + value;
    }
    return queryParameters;
};

const getValueWithOrWithoutQuotes = (key, rawValue) => {
    const withoutQuotes = ['query_fields', 'query_operator'];
    if (key === 'query_value') {
        if (rawValue.includes(" ")) {
            return '"' + rawValue + '"';
        }
        else {
            return rawValue;
        }
    }
    else if (withoutQuotes.indexOf(key) === -1) {
        return '"' + rawValue + '"';
    }
    else {
        return rawValue;
    }
};

export default getQueryParametersFromActiveFilters;
